import React from 'react';
import '../components/login/login.css';
import Updatepassword from '../components/login/UpdatePassword';


const LoginNewPassword = () => {
  return (
    <div className='login'>
        <Updatepassword/> 
    </div>
  );
}

export default LoginNewPassword;
